document.addEventListener("DOMContentLoaded", function () {
  // Find the video element by its ID
  var autovideo = document.getElementById("autoplay_video");
  var video = autovideo.querySelector("video");
  // Set autoplay to true
  video.autoplay = true;
  video.loop = true;
  video.muted = true;

  // Optionally, you can also play the video immediately
  video.play();
});

$(document).ready(function(){
    
    // announcement-bar js
    $('.announcement-bar').slick({
        autoplay : true,
        autoplaySpeed : 3000, 
        speed: 800,
        slidesToShow : 1,
        arrows : false,
        dots : false,
        pauseOnHover: true
    });
    
    // mobile js
    if ($(window).width() <= 720 ){
        $("#shopify-section-static-announcement").appendTo("#shopify-section-static-basic-header");
    }
    // desk js
    else{
        // on hover zooom image
        $(".product-gallery--image-background").on("mouseover", function() {
            $(this).children("img").css({ 
                transform: "scale(2.2)",
                transition: ".25s ease"
            });
        }).on("mouseout", function() {
            $(this).children("img").css({ transform: "scale(1)" });
        }).on("mousemove", function(e) {
            $(this).children("img").css({
                transition: ".1s ease",
                "transform-origin":
                ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +"%"+
                ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +"%"
            });
        });
    }
    
    // pdp gallery slider
    $('#pdp-slider').slick({  
        slidesToShow : 2,
        slideToScroll: 2,
        arrows : true,
        dots:true,
        responsive: [
            {
                breakpoint: 719,
                settings:{
                    slidesToShow : 1,
                    slideToScroll: 1,
                }
            }
        ]
    });
    
    $(document).on('click','.productgrid--sidebar-title--small',function(){
        $(this).toggleClass('active');
        $(this).siblings().slideToggle(300);
    });
  
  function equalHeight($trigger) {
  	  var highestBox = 0;
      $($trigger).each(function(){        
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }   
      });
      $($trigger).height(highestBox);
  }

    equalHeight('.productgrid--items .productitem--title');
    equalHeight('.productgrid--item .productitem--title');
    $('.faq_que').click(function(){
     $(this).parent().toggleClass('active');
     $(this).siblings('.faq_ans').slideToggle('250');
  });
  
  $('.tablinks').click(function(e){
    e.stopPropagation();
    e.preventDefault();
    var link = $(this).attr('href');
    // console.log(link);
    $(location).attr('href', link); 
  });
  
  $("a[href^='#CustJoinUsFooter']").click(function(e) {
              e.preventDefault();

              var position = $($(this).attr("href")).offset().top - 200;

              $("body, html").animate({
                scrollTop: position
              } ,2000 );
  });
  
// start product page afterpay klarna js
jQuery(".afterpay-text1").text("4 fortnightly payments of ");
jQuery(".afterpay-text2").text(" with ");
jQuery(".afterpay-link").html('<img class="afterpay-logo-moreLink" src="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png" srcset="https://static.afterpay.com/integration/product-page/logo-afterpay-colour.png 1x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@2x.png 2x, https://static.afterpay.com/integration/product-page/logo-afterpay-colour@3x.png 3x" width="100" height="21" alt="Afterpay" style="vertical-align: middle; width: 100px; border: 0px;">');
jQuery(".afterpay-link").after('<img class="klarna-logo-moreLink" src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.png" width="100" height="30" alt="Klarna" style="vertical-align: middle; width: 100px; border: 0px;">');
jQuery(".klarna-logo-moreLink").after('<img class="Zip-logo-moreLink" src="https://static.zipmoney.com.au/assets/default/logos/primary.png" width="100" height="30" alt="Zip" style="vertical-align: middle; width: auto; border: 0px;margin-left:-46px;margin-bottom:11px;">');
  jQuery(".afterpay-logo").css("display","none");  
// end product page afterpay klarna zip js
  
// start product page sizechart js  
  $('#sizeChartTrigger').click(function(){
    $('#chartPopupWrapper').addClass('open');
    $('body').css('overflow-y','hidden');
  });

  $('#closeSizeChart').click(function(){
    $('#chartPopupWrapper').removeClass('open');
    $('body').css('overflow-y','auto');
  });
// end product page sizechart js
  
});

// start product page sizechart popup js
function openTab(evtMain, TabNameMain) {
  var iMain, tabcontentMain, tablinksMain;
  tabcontentMain = document.getElementsByClassName("tabcontent");
  for (iMain = 0; iMain < tabcontentMain.length; iMain++) {
    tabcontentMain[iMain].style.display = "none";
  }
  tablinksMain = document.getElementsByClassName("tablinks");
  for (iMain = 0; iMain < tablinksMain.length; iMain++) {
    tablinksMain[iMain].className = tablinksMain[iMain].className.replace(" active", "");
  }
  document.getElementById(TabNameMain).style.display = "block";
  evtMain.currentTarget.className += " active";
}
function opensubTab(evtSub, TabNameSub) {
  var iSub, tabcontentSub, tablinksSub;
  tabcontentSub = document.getElementsByClassName("tabcontentsub");
  for (iSub = 0; iSub < tabcontentSub.length; iSub++) {
    tabcontentSub[iSub].style.display = "none";
  }
  tablinksSub = document.getElementsByClassName("tablinkssub");
  for (iSub = 0; iSub < tablinksSub.length; iSub++) {
    tablinksSub[iSub].className = tablinksSub[iSub].className.replace(" active", "");
  }
  document.getElementById(TabNameSub).style.display = "block";
  evtSub.currentTarget.className += " active";
}
function opensubParentTab(evtPerentSub, TabNamePerentSub) {
  var iPerentSub, tabcontentPerentSub, tablinksPerentSub;
  tabcontentPerentSub = document.getElementsByClassName("tabcontentsubperent");
  for (iPerentSub = 0; iPerentSub < tabcontentPerentSub.length; iPerentSub++) {
    tabcontentPerentSub[iPerentSub].style.display = "none";
  }
  tablinksPerentSub = document.getElementsByClassName("tablinksperent");
  for (iPerentSub = 0; iPerentSub < tablinksPerentSub.length; iPerentSub++) {
    tablinksPerentSub[iPerentSub].className = tablinksPerentSub[iPerentSub].className.replace(" active", "");
  }
  document.getElementById(TabNamePerentSub).style.display = "block";
  evtPerentSub.currentTarget.className += " active";
}
// end product page sizechart popup js